import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import AdminLayout from "./AdminLayout";

const STATUS_STYLE = { new: "bg-accent/15 text-accent", handled: "bg-secondary text-muted-foreground" };

export default function AdminEnquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/admin/enquiries").then((r) => setItems(r.data)).finally(() => setLoading(false)); };
  useEffect(load, []);

  const mark = async (e) => {
    try { await api.patch(`/admin/enquiries/${e.id}`, { status: "handled" }); toast.success("Marked handled"); load(); }
    catch (err) { toast.error(apiErr(err)); }
  };

  return (
    <AdminLayout title="Enquiries">
      {loading ? (
        <div className="space-y-3">{[...Array(3)].map((_, i) => <div key={i} className="h-28 rounded-md bg-secondary/60 animate-pulse" />)}</div>
      ) : items.length === 0 ? (
        <p className="text-muted-foreground py-16 text-center">No enquiries yet.</p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2" data-testid="admin-enquiries">
          {items.map((e) => (
            <div key={e.id} className="rounded-md border border-primary/10 bg-card p-5" data-testid={`enquiry-${e.id}`}>
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold uppercase text-accent">{e.experience_title || "Trip"}</span>
                <span className={`text-xs font-semibold uppercase px-2.5 py-0.5 rounded-full ${STATUS_STYLE[e.status]}`}>{e.status}</span>
              </div>
              <h3 className="font-semibold text-foreground mt-1">{e.name}</h3>
              <p className="text-sm text-muted-foreground">{e.email} · {e.phone || "no phone"}</p>
              <p className="text-sm text-foreground/80 mt-2">{e.message || "—"}</p>
              <p className="text-xs text-muted-foreground mt-2">Dates: {e.dates || "—"} · {e.guests} guest(s)</p>
              {e.status === "new" && (
                <button onClick={() => mark(e)} className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-primary text-primary-foreground px-3 py-1.5 text-xs font-semibold" data-testid={`handle-${e.id}`}>
                  <Check size={14} /> Mark handled
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
